var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeCredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home_Credit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 3C4.45 3 0 7.25 0 12.55C0 14.35 0.55 16.1 1.55 17.6H6.35C5.35 16.85 4.6 15.75 4.2 14.55C3.85 13.35 3.85 12.05 4.25 10.85C4.65 9.65 5.45 8.6 6.45 7.85C7.5 7.1 8.7 6.7 10 6.7C11.25 6.7 12.5 7.1 13.55 7.85C14.6 8.6 15.35 9.65 15.75 10.85C16.15 12.05 16.15 13.35 15.8 14.55C15.45 15.75 14.7 16.85 13.65 17.6H18.45C19.45 16.1 19.95 14.35 20 12.55C20 7.25 15.55 3 10 3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.75 14.1499C6.95 14.8499 7.4 15.4499 8 15.8499C8.6 16.2999 9.3 16.4999 10 16.4999C10.7 16.4999 11.45 16.2499 12 15.8499C12.6 15.3999 13 14.8499 13.25 14.1499H6.75Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeCredit);
export default __webpack_public_path__ + "static/media/home_credit.b4b15f62bb99e3f2a7d9b47ae8e7cf83.svg";
export { ForwardRef as ReactComponent };